// Guarded SW registration — never activates in Lovable preview or iframes.
export function registerPwa(): void {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  const host = window.location.hostname;
  const isLocalhost = host === "localhost" || host === "127.0.0.1" || host.endsWith(".local");
  const isLovablePreview =
    host.includes("lovable.app") ||
    host.includes("lovable.dev") ||
    host.includes("lovableproject.com");
  if (isLocalhost || isLovablePreview) return;
  try {
    if (window.self !== window.top) return;
  } catch {
    return;
  }
  import("virtual:pwa-register")
    .then(({ registerSW }) => {
      registerSW({ immediate: false });
    })
    .catch(() => {
      // virtual:pwa-register not available in this build — ignore silently
    });
}
